



  import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({})
export default class TextInputGroup extends Vue {
  @Prop({type: Boolean,  default: false}) isSearch?: boolean
}
